<template>
  <div class="admin-header">
    <v-container fluid class="px-0">
      <v-row class="flex justify-space-between" no-gutters>
        <!-- Logo/Title Section -->

        <v-col cols="8" lg="6" align-self="center">
          <div class="d-flex align-start flex-column">
            <div class="d-flex align-center">
              <v-icon size="24" class="mr-2" color="primary"
                >mdi-credit-card-outline</v-icon
              >
              <span class="font-roboto font-weight-medium text-h5">{{
                $t('message.transactions_admin_plus.transactions_header_title')
              }}</span>
            </div>
            <div class="page-subtitle">
              {{
                $t(
                  'message.transactions_admin_plus.transactions_header_subtitle',
                )
              }}
            </div>
          </div>
        </v-col>

        <!-- Actions Section -->
        <v-col cols="4" lg="6" align-self="center">
          <v-row
            cols="12"
            sm="6"
            md="4"
            no-gutters
            class="d-flex align-center justify-end"
          >
            <v-col cols="auto" class="d-none d-lg-flex">
              <PlusButton
                small
                intent="primary"
                class="mr-5"
                :disabled="disabledActions"
                @click="$emit('sell-item')"
              >
                <span class="font-roboto text-button d-none d-md-inline">{{
                  $t('message.transactions_admin_plus.sell_item')
                }}</span>
              </PlusButton>

              <PlusButton
                small
                intent="primary"
                class="mr-5"
                :disabled="disabledActions"
                @click="$emit('go-to-new-event')"
              >
                <span class="font-roboto text-button d-none d-md-inline">{{
                  $t('message.transactions_admin_plus.create_event')
                }}</span>
              </PlusButton>

              <PlusButton
                small
                intent="primary"
                :disabled="disabledActions"
                @click="$emit('detailed-report-dialog')"
              >
                <span class="font-roboto text-button d-none d-md-inline">{{
                  $t(
                    'message.transactions_admin_plus.transactions_header_download_short',
                  )
                }}</span>
              </PlusButton>
            </v-col>

            <v-col
              cols="auto"
              class="d-flex d-lg-none justify-end"
              v-if="!disabledActions"
            >
              <v-menu elevation="0" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-btn
                      class="ml-5 rounded-sm"
                      fab
                      small
                      outlined
                      elevation="0"
                      color="primary"
                    >
                      <v-icon size="20">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </span>
                </template>
                <v-list class="font-roboto text-body-1">
                  <v-list-item
                    class="d-flex d-lg-none"
                    v-if="!isSmallerDisplay()"
                    @click="$emit('sell-item')"
                  >
                    <v-list-item-title class="clickable">
                      <span>{{
                        $t('message.transactions_admin_plus.sell_item')
                      }}</span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    class="d-flex d-lg-none"
                    v-if="!isSmallerDisplay()"
                    @click="$emit('go-to-new-event')"
                  >
                    <v-list-item-title class="clickable">
                      <span>{{
                        $t('message.transactions_admin_plus.create_event')
                      }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('add-new-expense')">
                    <v-list-item-title class="clickable">
                      <span>{{
                        $t('message.transactions_admin_plus.add_expense')
                      }}</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('detailed-report-dialog')">
                    <v-list-item-title class="clickable">
                      <span>{{
                        $t('message.transactions_admin_plus.download_report')
                      }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PlusButton from '@/components/plus/PlusButton.vue';

export default {
  name: 'ViewTransactionsHeader',
  components: {
    PlusButton,
  },
  props: {
    payingCount: {
      type: Number,
      default: 0,
    },
    freeCount: {
      type: Number,
      default: 0,
    },
    upcomingBirthdays: {
      type: [Array, Boolean],
      default: false,
    },
    messagesThread: {
      type: [Object, Boolean],
      default: false,
    },
    disabledActions: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'sell-item',
    'go-to-new-event',
    'detailed-report-dialog',
    'add-new-expense',
  ],
  methods: {
    isSmallerDisplay() {
      return this.$vuetify.breakpoint.xs;
    },
  },
};
</script>

<style scoped>
.admin-header {
  margin-bottom: 1rem;
  /* plusBorder is theme-aware via Vuetify customProperties: #E0E0E0 (light) / #424242 (dark). */
  border-bottom: 1px solid var(--v-plusBorder-base);
  padding-bottom: 1rem;
  height: auto;
  flex: 1;
}
</style>
